/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * The main app bundle responsible for app configuration and client-side rendering.
 */
import 'quartz/framework/set-http-labs';
import * as AppRenderer from '../app-renderer';
import rhumbConfig from '$host-package-base-dir/rhumb-config.yaml';
import { i18nSetup } from '../internal/i18n/i18nSetup';
import { mark } from '../internal/perf';
import { quartzConfig } from 'quartz-config/evaluable';
mark('quartz.appEntry');
const lang = i18nSetup();
if ( /* quartzConfig.legacy_setupGeneralStore */false) {
  require('../internal/setup-general-store');
}
const App = require('$host-package-base-dir/js/+app');
if (process.env.NODE_ENV !== 'production') {
  if (typeof App.AppComponent === 'undefined') {
    throw new Error('Did you forget to export `AppComponent` from `+app.tsx`?');
  }
  if (typeof App.prepareApp !== 'function') {
    throw new Error('Did you forget to export or `prepareApp` from `+app.tsx`?');
  }
}
AppRenderer.renderApp(App, {
  rhumbConfig,
  lang
}).catch(err => {
  setTimeout(() => {
    throw err;
  });
});